import {
  ContactUsAction,
  useActionResult,
  useLocalePath,
} from "@commercekit/remix";
import { useEffect } from "react";
import { useFormContext } from "remix-validated-form";
import { useErrorAlert } from "./useErrorAlert";

export const useContactUs = () => {
  const localePath = useLocalePath();
  const { isSuccess, error } = useActionResult({
    action: localePath("/contact-us"),
    _action: ContactUsAction.CONTACT_US,
  });
  const FORM_ID = "contactUs";
  const { reset } = useFormContext(FORM_ID);
  const { show } = useErrorAlert();
  useEffect(() => {
    if (isSuccess) {
      reset();
    }
  }, [isSuccess, reset]);
  useEffect(() => {
    if (error && error.length) {
      show(error.join(","), "danger");
    }
  }, [error, show]);
  return { formId: FORM_ID };
};
